module.exports = __webpack_public_path__ + "media/add/wheel-add-03-6c8824c6.png";